module.exports = __webpack_public_path__ + "media/images/animations/axle_spacing/7-0a7afba5e91d5ad920cf069d2ae71830.png";